import { cn, MergeProps } from '@devsisters/wds-react';

type HRProps = React.ComponentPropsWithoutRef<'hr'>;
interface BaseProps {
  /**
   * @defaultValue `'horizontal'`
   */
  direction?: 'horizontal' | 'vertical';
}

type Props = MergeProps<HRProps, BaseProps>;
function Divider(props: Props) {
  const { direction = 'horizontal', className, ...hrProps } = props;

  return (
    <hr
      className={cn(
        'border-none bg-bg-line-base',
        direction === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
        className,
      )}
      {...hrProps}
    />
  );
}

export default Divider;
